import React from 'react'
import PropTypes from 'prop-types'
import Button from 'src/Components/shared/Button'
import { If } from 'src/Components'
import { EmailRealEstateAgent } from 'src/constants/trackingEvents'

const propTypes = {
  className: PropTypes.string,
  value: PropTypes.string
}

const Email = ({ value, text, ...restProps }) => (
  <If condition={value}>
    <Button
      data-qa='email'
      minimal
      element='a'
      href={`mailto:${value}`}
      track={EmailRealEstateAgent}
      {...restProps}
    >
      {text || value}
    </Button>
  </If>
)

Email.propTypes = propTypes

export default Email
